import React from "react";
import "./AICreditsModal.css";

export default function AICreditsModal({ open, onClose, imageCredits, translationCredits }) {
  if (!open) return null;

  return (
    <div className="ai-credits-overlay" onClick={onClose}>
      <div className="ai-credits-modal" onClick={(e) => e.stopPropagation()}>
        
        <h3 className="ai-credits-title">💳 Crediti AI</h3>

        <div className="ai-credits-list">
          <div className="ai-credit-item">
            <span>🖼️ Immagini</span>
            <strong>{imageCredits}</strong>
          </div>

          <div className="ai-credit-item">
            <span>🌍 Traduzioni</span>
            <strong>{translationCredits}</strong>
          </div>
        </div>

        <button className="ai-credits-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
}